module.exports = __webpack_public_path__ + "assets/icon-leads-component.94ccaed1.svg";